import { render, staticRenderFns } from "./ArchiveModalBox.vue?vue&type=template&id=6eb02aac"
import script from "./ArchiveModalBox.vue?vue&type=script&lang=ts"
export * from "./ArchiveModalBox.vue?vue&type=script&lang=ts"
import style0 from "./ArchiveModalBox.vue?vue&type=style&index=0&id=6eb02aac&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports